export interface IRapportConfig {
  interpolation: {
    prefix: string;
    suffix: string;
  };
  selectors: string[];
  convenience: {
    abbreviation: string[];
  };
  files: string[];
  webPackage: string;
}

export const defaultConfig: IRapportConfig = {
  interpolation: { prefix: "%{", suffix: "}" },
  selectors: ["_t", "_translate"],
  convenience: {
    abbreviation: ["_abbr", "_abbreviation"]
  },
  files: [
    "**/*.{js,jsx,ts,tsx}",
    "!**/*.test.*",
    "!node_modules",
    "!build",
    "!out"
  ],
  webPackage: "./rapport-web.json"
};
